export const getModalTypeSelector = (state: RootState) => state.globalModal.modalType;
